import React, { useState } from "react";

export default function EmployeeAttendanceCard() {
  const [attendance, setAttendance] = useState({
    name: "KrishnKant Sharma",
    present: "28 Day",
    absent: "1 Day",
    half: "2 Day",
    extraHours: "1 Hour",
    leaveType: "Sick Leave",
  });

  const handleChange = (key, value) => {
    setAttendance((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
  };

  // Helper function to generate options for days (0 to 31)
  const generateDayOptions = () => {
    const options = [];
    for (let i = 0; i <= 31; i++) {
      options.push(`${i} Day`);
    }
    return options;
  };

  // Helper function to generate options for hours (1 to 4)
  const generateHourOptions = () => {
    const options = [];
    for (let i = 1; i <= 4; i++) {
      options.push(`${i} Hour${i > 1 ? "s" : ""}`);
    }
    return options;
  };

  // Leave types options
  const leaveTypes = ["Sick Leave", "Casual Leave"];

  return (
    <div className="max-w-md mt-32 mx-auto p-6 bg-white rounded shadow-md">
      {/* Top section with Profile */}
      <div className="flex items-center mb-6">
        <img
          src="https://i.pravatar.cc/100"
          alt="Profile"
          className="w-16 h-16 rounded-full mr-4"
        />
        <div>
          <p className="text-sm text-gray-400">ID - Edu01</p>
          <p className="text-sm text-gray-600">yourname@gmail.com</p>
        </div>
      </div>

      {/* Employee Attendance Title */}
      <div className="border-t pt-3 mb-3">
        <h3 className="font-semibold text-lg text-gray-800">
          Employee Attendance
        </h3>
      </div>

      {/* Attendance Details */}
      <div className="space-y-4">
        {[
          { label: "Name", key: "name" },
          { label: "Present Day", key: "present" },
          { label: "Absent Day", key: "absent" },
          { label: "Half Day", key: "half" },
          { label: "Extra Hours at Work", key: "extraHours" },
          { label: "Leave Type", key: "leaveType" },
        ].map(({ label, key }) => (
          <div key={key} className="relative">
            <div className="flex justify-between items-center border-b pb-1">
              <span className="text-sm text-gray-700 font-medium">{label}</span>
              <select
                value={attendance[key]}
                onChange={(e) => handleChange(key, e.target.value)}
                className="text-sm text-right text-gray-600 bg-white focus:outline-none appearance-none cursor-pointer pr-8"
              >
                {key === "name" ? (
                  <option value={attendance[key]}>{attendance[key]}</option>
                ) : key === "extraHours" ? (
                  generateHourOptions().map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))
                ) : key === "leaveType" ? (
                  leaveTypes.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))
                ) : (
                  generateDayOptions().map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))
                )}
              </select>
              {/* Custom dropdown arrow */}
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Save Button */}
      <div className="text-right mt-5">
        <button
          onClick={handleSave}
          className="bg-[#2C4E86] hover:bg-blue-900 text-white py-2 px-6 rounded text-sm"
        >
          Save
        </button>
      </div>
    </div>
  );
}
